import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export function initSwiper() {
  const swiperElements = document.querySelectorAll(".swiper");

  swiperElements.forEach((swiperEl) => {
    const config = {};

    // Iterujemy przez wszystkie atrybuty data-*
    Array.from(swiperEl.attributes).forEach((attr) => {
      if (attr.name.startsWith("data-")) {
        const key = attr.name
          .replace("data-", "")
          .replace(/-([a-z])/g, (g) => g[1].toUpperCase()); // Konwersja do camelCase
        let value = attr.value;

        try {
          // Zamiana encji HTML &quot; na cudzysłowy "
          value = value.replace(/&quot;/g, '"');
          // Sprawdzenie, czy wartość jest JSON-em
          value = JSON.parse(value);
        } catch (e) {
          // Jeśli nie jest JSON-em, konwertujemy wartości proste
          if (value === "true") value = true;
          else if (value === "false") value = false;
          else if (!isNaN(value)) value = Number(value);
        }

        config[key] = value;
      }
    });

    // Dodaj moduły do konfiguracji
    config.modules = [Navigation, Pagination];

    // Uruchomienie Swiper.js z konfiguracją
    new Swiper(swiperEl, config);
  });
}
